import { render, staticRenderFns } from "./StandardSettingsDetail.vue?vue&type=template&id=bb743d02&scoped=true"
import script from "./StandardSettingsDetail.vue?vue&type=script&lang=js"
export * from "./StandardSettingsDetail.vue?vue&type=script&lang=js"
import style0 from "./StandardSettingsDetail.vue?vue&type=style&index=0&id=bb743d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb743d02",
  null
  
)

export default component.exports